import { useMediaQuery } from '@material-ui/core'
import { useAtom } from 'jotai'
import * as React from 'react'
import styled from 'styled-components'
import { FOLLOW_DIALOG_ACTIVE_TAB, followDialogActiveTabAtom } from '../../../atoms/profile'
import useAuth from '../../../hooks/auth'
import { EditProfileButton } from '../edit'
import FollowButton from './FollowButton'

// ============================ Styled components ==============================

const OuterDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: fit-content;
  /* margin: 14px 0; */
  gap: 25px;

  margin-top: 25px;
  margin-bottom: 25px;
`

const Item = styled.div`
  font-weight: 500;
  display: flex;
  font-size: 18px;
  text-align: right;
  align-items: center;

  // mobile
  @media (max-width: 43em) {
    font-size: 14px;
  }
`

const Count = styled.b`
  margin-right: 5px;
  font-size: 22px;
  font-weight: 600;

  // mobile
  @media (max-width: 43em) {
    font-size: 16px;
  }
`

const Title = styled.div`
  margin-right: 10px;
  color: #b1b1b1;
`

// ============================ Types ==========================================

type FollowChipProps = {
  followingCount: number | undefined
  followersCount: number | undefined
  address: string
}

// ============================ React component ================================

const FollowChip = ({ followingCount, followersCount, address }: FollowChipProps): JSX.Element => {
  const [, setFollowDialogActiveTab] = useAtom(followDialogActiveTabAtom)
  const [followers, setFollowers] = React.useState(followersCount ?? 0)
  const [following, setFollowing] = React.useState(followingCount ?? 0)
  const { profile } = useAuth()
  const isMyProfile = profile?.address === address
  const isTablet = useMediaQuery('(max-width: 62em)')
  const handleShowFollowing = () => {
    setFollowDialogActiveTab(FOLLOW_DIALOG_ACTIVE_TAB.FOLLOWING)
  }

  const handleShowFollowers = () => {
    setFollowDialogActiveTab(FOLLOW_DIALOG_ACTIVE_TAB.FOLLOWERS)
  }

  const onUpdateFollow = (follow: boolean): void => {
    if (follow) {
      setFollowers(followers + 1)
    } else {
      setFollowers(followers - 1)
    }
  }

  React.useEffect(() => {
    setFollowers(followersCount ?? 0)
  }, [followersCount])

  React.useEffect(() => {
    setFollowing(followingCount ?? 0)
  }, [followingCount])

  return (
    <OuterDiv>
      {isMyProfile ? (
        <EditProfileButton />
      ) : (
        <FollowButton onUpdate={onUpdateFollow} address={address || ''} />
      )}
      {!isTablet && (
        <Item
          onClick={following !== 0 ? handleShowFollowing : undefined}
          style={{ cursor: following !== 0 ? 'pointer' : '' }}
        >
          <Count>{following}</Count>
          <Title>Following</Title>
        </Item>
      )}
      {!isTablet && (
        <Item
          onClick={followers !== 0 ? handleShowFollowers : undefined}
          style={{ cursor: followers !== 0 ? 'pointer' : '' }}
        >
          <Count>{followers}</Count>
          <Title>Follower{followers !== 1 && 's'}</Title>
        </Item>
      )}
    </OuterDiv>
  )
}

export default FollowChip
